import React from 'react';

function FeaturesSection() {
    const featuresData = [
        {
            icon: "/assets/images/ico_stream.svg",
            title: "Reach New Audience",
            description: "Stream your content on 15+ major platforms including Roku, Fire TV, Samsung TV, LG, iOS, and Android — with no upfront cost."
        },
        {
            icon: "/assets/images/ico_Smart.svg",
            title: "Higher Discoverability",
            description: "With no paywalls and a free viewing model, your content becomes more discoverable and accessible to millions of viewers."
        },
        {
            icon: "/assets/images/ico_revenue.svg",
            title: "Content Monitization",
            description: "Earn from Ad-supported Video-On-Demand (AVOD). The more impressions your content generates, the more revenue you earn."
        },
        {
            icon: "/assets/images/ico_diverse.svg",
            title: "Video Diversity",
            description: "We welcome movies, series, short films, documentaries, animation, and creator-driven videos across genres and languages."
        }
    ];

    return (
        <section className="partnership-section features-section">
            <div className="container-fluid features-container">
                <div className="text-center mb-4">
                    <h2 className="partnership-title">
                        Why Fawesome Stands Out
                    </h2>
                </div>

                <div className="row g-5">
                    {featuresData.map((feature, index) => (
                        <div className="col-xl-3 col-lg-6 col-md-6" key={index}>
                            <div className="feature-card">
                                <div className="feature-icon-wrapper">
                                    <img
                                        src={feature.icon}
                                        alt={feature.title}
                                        className="feature-icon-img"
                                    />
                                </div>
                                <h4 className="feature-title">
                                    {feature.title}
                                </h4>
                                <p className="feature-description">
                                    {feature.description}
                                </p>
                            </div>
                        </div>
                    ))}
                </div>
            </div>

            {/* DIVFOOTER 2 - Bottom transition divider */}
            <div className="partnership-footer-divider">
                <img
                    src="/assets/images/divfooter2.svg"
                    alt=""
                    className="img-fluid"
                />
            </div>
        </section>
    );
}

export default FeaturesSection;
